export default "__VITE_ASSET__CgSZT4ZJ__"